import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Default = all visible. If backend fails/loads slow, nothing gets hidden.
const DEFAULT_VISIBILITY = {
  hero: true,
  stats: true,
  team: true,
  products: true,
  initiatives: true,
  demo: true,
  research: true,
  publications: true,
  press: true,
  events: true,
  partners: true,
  contact: true,
};

const SiteContentContext = createContext({
  visibility: DEFAULT_VISIBILITY,
  loading: true,
});

export const SiteContentProvider = ({ children }) => {
  const [visibility, setVisibility] = useState(DEFAULT_VISIBILITY);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    axios
      .get(`${API}/content/section-visibility`)
      .then((res) => {
        if (alive && res.data?.sections) {
          setVisibility({ ...DEFAULT_VISIBILITY, ...res.data.sections });
        }
      })
      .catch(() => {})
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  return (
    <SiteContentContext.Provider value={{ visibility, loading }}>
      {children}
    </SiteContentContext.Provider>
  );
};

export const useSiteContent = () => useContext(SiteContentContext);
